module.exports = __webpack_public_path__ + "img/lb_lbsq.be885b80.svg";